import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import ReactSelect from "react-select";
import { DownArrowAction, Plus, Search } from "../../assets/svg";
import { InputError } from "../error/error";
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import {
  DateRangeIcon,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export const Icon = ({ iconName, size, color }) => {
  const IconName = require(`iconsax-react`)[iconName];
  return <IconName size={size} color={color} />;
};

export const StartDateOfMonth = () => {
  var currentDate = new Date();
  const startDateOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );
  return startDateOfMonth;
};

export const DefaultPhoneInput = ({
  value,
  onChange,
  defaultCountry = "IN",
  ...res
}) => {
  return (
    <PhoneInput
      international
      countryCallingCodeEditable={false}
      defaultCountry={defaultCountry}
      value={value}
      onChange={onChange}
      {...res}
    />
  );
};

export const Input = ({ className, ...res }) => {
  return <input className={`${className} w-full`} {...res} />;
};

export const Badge = ({ className, value, ...res }) => {
  return (
    <p
      className={`border rounded-full lg:px-3 px-1 py-2 lg:text-[13px] font-normal text-center font-Proxima ${className}`}
      {...res}
    >
      {value}
    </p>
  );
};

export const AddButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-themeBtn text-sm font-normal text-white flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima shadow-[0_4px_6px_rgba(0,0,0,0.3)] w-full sm:w-auto"
        type="button"
        {...res}
      >
        <Plus className="fill-white mr-2" />
        <p>{value}</p>
      </button>
    </div>
  );
};

export const PrimaryButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-themeBtn text-white flex items-center justify-center sm:px-4 px-1 py-2.5 rounded uppercase font-Proxima w-full sm:w-auto"
        type="button"
        {...res}
      >
        <p>{value}</p>
      </button>
    </div>
  );
};

export const PrimaryCancelButton = ({ className, value, ...res }) => {
  return (
    <div className={`flex justify-center py-3 ${className}`}>
      <button
        className="bg-white text-themeBtn border border-themeBtn flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima w-full sm:w-auto"
        type="button"
        {...res}
      >
        <p>{value}</p>
      </button>
    </div>
  );
};

export const DropdownAddButton = ({
  className,
  value,
  options = [],
  onClick,
  ...res
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setIsOpen(false);
    if (onClick) {
      onClick(option);
    }
  };
  return (
    <div className={`flex justify-center py-3 relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-themeBtn text-white flex items-center justify-center px-4 py-2.5 rounded uppercase font-Proxima shadow-[0_4px_6px_rgba(0,0,0,0.3)] w-full sm:w-auto"
        type="button"
        {...res}
      >
        <Plus className="fill-white mr-2" />
        <p>{value}</p>
      </button>
      {isOpen && options.length > 0 && (
        <ul className="absolute top-12 -left-10 bg-bgWhite mt-2 shadow-lg z-10 right-0 w-[190px] rounded">
          {options.map((option, index) => (
            <li
              key={index}
              className="px-4 py-2 hover:bg-hoverTheme cursor-pointer font-Proxima"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const DropdownAction = ({
  className,
  value,
  options = [],
  onClick,
  ...res
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setIsOpen(false);
    if (onClick) {
      onClick(option);
    }
  };
  return (
    <div className={`relative ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-themeBtn flex items-center font-Proxima justify-center px-6 py-2 rounded border border-themeBtn uppercase w-full sm:w-auto"
        type="button"
        {...res}
      >
        <p>{value}</p>
        <DownArrowAction className="fill-themeBtn ml-2" />
      </button>
      {isOpen && options.length > 0 && (
        <ul className="absolute bg-bgWhite mt-2 shadow-lg z-10 right-0 w-[190px] rounded">
          {options.map((option, index) => (
            <li
              key={index}
              className="px-4 py-2 hover:bg-hoverTheme cursor-pointer"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const AddPrimaryButton = ({
  className,
  value,
  height,
  width,
  ...res
}) => {
  return (
    <div className={`flex justify-center ${className}`}>
      <button
        className="text-themeBtn flex items-center justify-center px-6 py-2.5 rounded border border-themeBtn w-full sm:w-auto"
        type="button"
        {...res}
        style={{ height, width }}
      >
        <Plus className="fill-themeBtn mr-2" />
        <p>{value}</p>
      </button>
    </div>
  );
};

export const DefaultButton = ({ className, type, value, ...res }) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className="bg-themeBtn text-bgWhite flex items-center justify-center px-6 py-2.5 rounded uppercase font-Proxima w-full sm:w-auto"
        type={type ?? "button"}
        {...res}
      >
        <p className="font-Proxima font-normal text-[15px]">{value}</p>
      </button>
    </div>
  );
};
export const DisableButton = ({ className, type, value, ...res }) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className="bg-borderDot text-borderGrey flex items-center justify-center px-6 py-2.5 rounded uppercase font-Proxima w-full sm:w-auto"
        type={type ?? "button"}
        {...res}
      >
        <p className="font-Proxima font-normal text-[15px]">{value}</p>
      </button>
    </div>
  );
};

export const DefaultPrimaryButton = ({
  className,
  value,
  height,
  width,
  onClick,
  ...res
}) => {
  return (
    <div className={`flex justify-center py-2 ${className}`}>
      <button
        className="text-themeBtn flex items-center justify-center px-6 py-2 rounded border border-themeBtn font-Proxima w-full sm:w-auto"
        type="button"
        {...res}
        style={{ height, width }}
        onClick={onClick}
      >
        <p className="font-Proxima text-[15px] uppercase">{value}</p>
      </button>
    </div>
  );
};

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  errors,
  errorsText,
  inputClass,
  className = "",
  ...res
}) => {
  return (
    <div className={`${className} relative flex items-center w-full`}>
      <span className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <Search />
      </span>
      <Input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`pl-10 pr-3 py-2 text-sm bg-white w-full rounded border border-grey focus:outline-none ${inputClass}`}
        {...res}
      />
      {errors && <InputError errorTitle={errorsText} />}
    </div>
  );
};

export const InputWithLabel = ({
  className,
  idFromName,
  label,
  type = "text",
  errors,
  inputClass,
  errorsText,
  disabled,
  icon,
  rows,
  ...res
}) => {
  return (
    <div>
      <div
        className={`${className} relative bg-white transition duration-300 rounded`}
      >
        {type === "textarea" ? (
          <textarea
            id={idFromName}
            name={idFromName}
            disabled={disabled}
            rows={rows}
            className={`block px-2.5 pb-2.5 pt-4 w-full text-sm error-forms bg-transparent rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer h-12 ${inputClass}`}
            placeholder={" "}
            {...res}
          />
        ) : (
          <Input
            type={type}
            id={idFromName}
            disabled={disabled}
            name={idFromName}
            className={`block px-2.5 py-2 w-full text-sm error-forms bg-transparent rounded 
              border-borderTheme/80 appearance-none focus:outline-none focus:ring-0 peer ${inputClass}`}
            placeholder={" "}
            {...res}
          />
        )}
        <label
          htmlFor={idFromName}
          className="absolute text-textGrey pointer-events-none text-base bg-white duration-300 transform -translate-y-5 scale-75 top-2 origin-[0] px-2 peer-focus:px-2 peer-focus peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 left-1 font-Proxima"
        >
          {label}
        </label>
        {icon && <>{icon}</>}
      </div>
      {errors ? <InputError errorTitle={errorsText} /> : null}
    </div>
  );
};

export const TextareaWithLabel = ({
  className,
  idFromName,
  label,
  errors,
  errorsText,
  inputClass,
  icon,
  ...res
}) => {
  return (
    <div className="w-full">
      <div
        className={`relative bg-white border transition duration-300 rounded ${className}`}
      >
        <textarea
          id={idFromName}
          name={idFromName}
          className={`block px-3 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded border appearance-none focus:outline-none focus:ring-0 focus:border-themeBtn peer ${inputClass}`}
          placeholder=" "
          {...res}
        />
        <label
          htmlFor={idFromName}
          className="absolute text-light_grey text-base bg-white px-2 transition-all duration-300 transform -translate-y-5 scale-75 top-2 left-1 z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5"
        >
          {label}
        </label>
      </div>
      {errors && <InputError errorTitle={errorsText} />}
    </div>
  );
};

export const RadioButton = ({
  className,
  idFrom,
  name,
  value,
  label,
  ...res
}) => {
  return (
    <label
      htmlFor={idFrom}
      className={`flex items-center space-x-2 ${className}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        id={idFrom}
        className="peer hidden"
        {...res}
      />
      <span className="w-5 h-5 border-2 border-textSecondary rounded-full peer-checked:border-themeBtn relative peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:rounded-full peer-checked:after:w-3 peer-checked:after:h-3 peer-checked:after:bg-themeBtn peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2"></span>
      <p className="text-sm md:text-base text-mgrey">{label}</p>
    </label>
  );
};

export const InformationTag = ({ type, text, size, ...res }) => {
  const colorClass =
    type === "success"
      ? "text-success bg-green-100"
      : type === "error"
      ? "text-red bg-red-100"
      : "";
  return (
    <div
      className={`flex items-center space-x-3 rounded px-3 md:px-5 py-2 md:py-3 ${colorClass}`}
      {...res}
    >
      <span className="text-sm md:text-base">{text}</span>
    </div>
  );
};

export const CheckBox = ({
  className,
  idFrom,
  name,
  label,
  labelClass,
  ...res
}) => {
  return (
    <label
      htmlFor={idFrom}
      className={`flex items-center space-x-2 ${className}`}
    >
      <input
        type="checkbox"
        name={name}
        id={idFrom}
        className="peer hidden"
        {...res}
      />
      <span className="w-5 h-5 border-2 border-secondary_grey rounded peer-checked:border-theme relative peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:w-full peer-checked:after:h-[calc(100%+3px)] peer-checked:after:bg-check_img peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2"></span>
      <p className={`text-sm md:text-base ${labelClass}`}>{label}</p>
    </label>
  );
};

export const Tooltip = ({
  tooltipLabel,
  label,
  labelClass,
  tooltipLabelClass,
  isLeft,
  alwaysVisible,
  ...res
}) => {
  return (
    <div className="relative group" {...res}>
      <button className={labelClass}>{label}</button>
      <div
        className={`absolute z-20 top-28 w-60 hidden group-hover:block bg-navTheme text-white text-xs px-4 py-2 rounded ${tooltipLabelClass} ${
          isLeft
            ? "right-full top-1/2 -translate-y-1/2 -translate-x-5 -mr-2"
            : "bottom-full left-1/2 -translate-x-1/2 mb-2"
        }`}
      >
        {tooltipLabel}
        <div
          className={`absolute w-0 h-0 ${
            isLeft
              ? "top-1/2 left-full border-l-8 border-l-navTheme border-t-8 border-t-transparent border-b-8 border-b-transparent -translate-y-1/2"
              : "top-full left-1/2 border-t-8 border-t-navTheme border-l-8 border-l-transparent border-r-8 border-r-transparent -translate-x-1/2"
          }`}
        ></div>
      </div>
    </div>
  );
};

export const SelectBox = ({
  options,
  placeholder,
  errors,
  errorsText,
  className,
  disabled,
  ...res
}) => {
  return (
    <div className="w-full">
      <ReactSelect
        className={`text-black font-Proxima ${className}`}
        placeholder={placeholder}
        options={options}
        isClearable
        isSearchable={false}
        isDisabled={disabled}
        {...res}
        styles={{
          control: (base) => ({
            ...base,
            border: disabled
              ? "1px dashed #D3D3D3"
              : errors
              ? "1px solid red"
              : "1px solid #0000003B",
            backgroundColor: "white",
            borderRadius: "0.25rem",
            boxShadow: "none",
          }),
        }}
      />
      {errors && <InputError errorTitle={errorsText} />}
    </div>
  );
};

export const SelectWithLabel = ({
  idFromName,
  placeholder,
  errors,
  touched,
  options,
  value,
  setFieldValue,
  className,
  onChange,
  disabled,
  multiple,
  renderValue,
  input,
  endAdornment,
  fontSize = "16px",
  helperText,
  ...res
}) => {
  return (
    <div>
      <FormControl fullWidth size="small" className={className}>
        <InputLabel id={`${idFromName}-label`}>{placeholder}</InputLabel>
        <Select
          id={idFromName}
          value={value}
          label={placeholder}
          input={input}
          renderValue={renderValue}
          color="warning"
          endAdornment={endAdornment}
          multiple={multiple}
          onChange={onChange}
          disabled={disabled}
          {...res}
          className="font-Proxima"
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: "300px",
                overflowY: "auto",
                maxWidth: "100%",
                "& .MuiMenuItem-root": {
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(241, 91, 41, 0.12)",
                  },
                },
              },
            },
          }}
          sx={{
            "& .MuiSelect-select": {
              fontSize: fontSize,
              fontFamily: "proxima_nova",
            },
            "& .MuiInputBase-input": {
              fontSize: fontSize,
            },
            ...(disabled && {
              border: "1px dashed #ccc",
              borderRadius: "4px",
            }),
          }}
          InputLabelProps={{
            sx: {
              "&.Mui-focused": {
                color: "#f15b29",
              },
            },
          }}
        >
          {options?.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              className="font-Proxima text-base"
            >
              {option?.label}
            </MenuItem>
          ))}
        </Select>
        {errors && touched ? <InputError errorTitle={errors} /> : null}
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
};

export const DatePicker = ({
  id,
  value,
  onChange,
  label,
  error,
  touched,
  disabled = false,
  name,
  maxDate,
  icon = <DateRangeIcon />,
  ...props
}) => {
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <MobileDatePicker
          id={id}
          value={value}
          label={label}
          onChange={onChange}
          disabled={disabled}
          format="DD/MM/YYYY"
          maxDate={maxDate}
          slotProps={{
            textField: {
              size: "small",
              variant: "outlined",
              label,
              fullWidth: true,
              color: "warning",
              error: Boolean(error && touched),
              sx: {
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#F15B29",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#F15B29",
                    borderWidth: "1px",
                  },
                },
              },
              InputProps: (params) => ({
                ...params.InputProps,
                endAdornment: (
                  <>
                    {params.InputProps?.endAdornment}
                    <InputAdornment position="end">{icon}</InputAdornment>
                  </>
                ),
              }),
            },
            actionBar: {
              sx: {
                "& .MuiButton-root": {
                  color: "#F15B29",
                },
                "& .MuiButton-root.Mui-cancelButton": {
                  color: "gray",
                },
              },
            },
            day: {
              sx: {
                "&.MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#F15B29",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#F15B29",
                  },
                },
              },
            },
          }}
          InputLabelProps={{
            shrink: true,
            sx: {
              "&.Mui-focused": {
                color: "red !important",
              },
              "&.MuiInputLabel-shrink": {
                color: "red !important",
              },
            },
          }}
          {...props}
        />
      </LocalizationProvider>

      {error && touched && <InputError errorTitle={error} />}
    </div>
  );
};
